export default __webpack_public_path__ + "static/media/step_014.a00914bd.png";